import React from 'react';
import {Modal, TouchableWithoutFeedback} from 'react-native';

import {Button} from '../../../../../../components/Interface/Forms/Buttons/Button';
import {LinkButton} from '../../../../../../components/Interface/Forms/Buttons/LinkButton';

import {
  ModalOverlay,
  ModalContent,
  IconWrapper,
  Icon,
  ModalTitle,
  ModalText,
  ButtonWrapper,
  LinkButtonWrapper,
} from './styles';

interface Props {
  visible: boolean;
  onClose: () => void;
  onValidate: () => void;
  dismissable?: boolean;
}

export function PhoneVerificationModal({
  visible,
  onClose,
  onValidate,
  dismissable = true,
}: Props) {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={dismissable ? onClose : undefined}>
      <TouchableWithoutFeedback
        onPress={dismissable ? onClose : undefined}>
        <ModalOverlay>
          <TouchableWithoutFeedback>
            <ModalContent>
              <IconWrapper>
                <Icon name="cellphone-check" />
              </IconWrapper>

              <ModalTitle>Confirme seu número de celular</ModalTitle>
              <ModalText>
                Para sua segurança, você precisa validar seu número de celular
                por SMS antes de consultar débitos veiculares.
              </ModalText>

              <ButtonWrapper>
                <Button title="Validar celular" enabled onPress={onValidate} />
              </ButtonWrapper>

              {dismissable && (
                <LinkButtonWrapper>
                  <LinkButton action={onClose} enabled text="Agora não" />
                </LinkButtonWrapper>
              )}
            </ModalContent>
          </TouchableWithoutFeedback>
        </ModalOverlay>
      </TouchableWithoutFeedback>
    </Modal>
  );
}
